<template>
  <div :id="inputDivId" class="select-multi-level comp-start">
    <div class="select-card-ques">
      {{ info.message }}
    </div>
    <div id="multiLevelDropdown" class="dropdown">
      <button
        id="dropdownMenuButton"
        class="btn dropdown-button"
        type="button"
        data-display="static"
        @click="onClickMenu($event)"
      >
        <span
          :style="dDWidth"
          class="float-left select-placeholder"
          :class="selectedItems.length > 0 ? '' : 'select-placeholder-default'"
        >
          {{ selectPlaceholder }}
          <span
            v-if="selectedItems.length > 0 || null"
            class="select-remove-all"
            @click="onClickRemoveAll($event)"
            ><img src="@/assets/img/list-cross-icon.png"
          /></span>
        </span>
        <span class="float-right button-arrows dropdown-button-arrow-img">
          <img
            v-if="showIcon || null"
            class="dropdown-button-arrow-img"
            src="@/assets/img/dropdown-up-icon.png"
          />
          <img
            v-else
            class="dropdown-button-arrow-img"
            src="@/assets/img/dropdown-icon.png"
          />
        </span>
      </button>

      <div v-show="showIcon" class="dropdown-menu">
        <div id="search-btn" style="display: flex">
          <img
            v-if="enableSearch ? true : null"
            src="@/assets/img/Group.svg"
            class="search-icon"
          />

          <input
            v-if="enableSearch ? true : null"
            id="search"
            ref="search"
            v-model="search"
            type="text"
            :placeholder="searchPlaceholder"
            class="search-dropdown"
          />
        </div>

        <form
          v-if="showItems || null"
          id="dropdown-scroll"
          class="dropdown-scroll"
        >
          <div
            v-for="(item, itemIndex) in allList"
            :key="itemIndex"
            class="dropdown-item-row"
          >
            <SelectMultiLevelItems
              :key="itemIndex"
              :list="item"
              :depth="1"
              :question-id="info.id"
              :selected-items="selectedItems"
              :search-val="search"
              :item-offset-val="itemOffsetMain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- - Display selected items - Start -->
    <div v-show="!showIcon" class="selected-item-container">
      <div
        v-for="(selItem, selItemIndex) in selectedItems"
        :key="selItemIndex"
        class="selected-item-card"
        @click="onRemoveItem(selItemIndex)"
      >
        <span>{{ selItem.name }}</span>
        <span class="item-close"
          ><img src="@/assets/img/list-cross-icon.png"
        /></span>
      </div>
    </div>
    <!-- - Display selected items - End -->
  </div>
</template>
<script lang="ts">
import { Component, Prop, Watch } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import _ from "underscore";
import Utils from "@/utils/utilities";
import $ from "jquery";
import SelectMultiLevelItems from "@/components/prospect/prospectQuestions/componentTypes/selectMultiLevelItems.vue";
import store from "@/store";
import EventEmitter from "@/utils/eventEmitter";

const selectDefaultPlaceholder = "Select";

@Component({
  components: {
    SelectMultiLevelItems,
  },
})
export default class SelectMultiLevel extends Vue {
  public allList: any = [];
  public masterList: any = [];
  public search = "";
  public selectedItems: any = [];
  public selectPlaceholder: string = selectDefaultPlaceholder;
  public showIcon = false;
  public sampList: any = [];
  public showItems = true;
  public valsToFind: any = [];
  public primaryPlaceholder = "";
  public inputDivId = "";
  public itemOffsetMain = -1;
  public dropdownWidth = 100;
  public longestItem = "";
  public longestItemLevel = 0;
  public searchPlaceholder = "Search..";

  @Prop()
  public info!: any;

  @Prop()
  public enableSearch!: boolean;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("showIcon")
  onClickMenuButton() {
    if (!this.showIcon) {
      this.search = "";
    }
  }
  @Watch("languageList")
  changeLanguageList() {
    this.updateUIVariables();
  }

  adjustDropdownWidth() {
    const maxPlaceHolder =
      "100 " + this.getUiText("app-prospect-questions-items-selected-text");
    const selectedPlaceHolder =
      this.primaryPlaceholder.length > maxPlaceHolder.length
        ? this.primaryPlaceholder
        : maxPlaceHolder;

    const custwidth1 = Utils.dropDownFitContent(
      [],
      selectedPlaceHolder,
      "multiLevel",
      false,
    );
    const custwidth2 = Utils.dropDownFitContent(
      [],
      this.longestItem,
      "multiLevel",
      true,
    );
    this.dropdownWidth = custwidth1 > custwidth2 ? custwidth1 : custwidth2;
    if (custwidth2 > custwidth1 && this.longestItemLevel > 0) {
      this.dropdownWidth =
        this.dropdownWidth + (this.longestItemLevel * 30 - 10);
    }
  }

  get dDWidth() {
    return {
      width: `${
        window.innerWidth > 500 ? this.dropdownWidth + 35 + "px" : "100%"
      } !important`,
      "padding-bottom": "0px",
    };
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  updateUIVariables() {
    this.searchPlaceholder = this.getUiText(
      "app-prospect-questions-search-text-1",
    );
  }

  addChildIdsString(list: any) {
    let id = "";

    const tempArr: any = [];
    if ((list as any).industry_group) {
      for (let j of list.industry_group) {
        if ((j as any).industry) {
          const temp = (j as any).industry.map((item) => item.id);
          id = `${id}-${temp.join("-")}`;
          j.childIds = temp.join("-");
          tempArr.push(j);
        }
      }
    }

    if ((list as any).asset_types) {
      for (let j of list.asset_types) {
        if ((j as any).asset_types) {
          const temp = (j as any).asset_types.map((item) => item.id);
          id = `${id}-${temp.join("-")}`;
          j.childIds = temp.join("-");
          tempArr.push(j);
        }
      }
    }

    if ((list as any).service_types) {
      const temp = (list as any).service_types.map((item) => item.id);
      id = `${id}-${temp.join("-")}`;
      (list as any).childIds = temp.join("-");
      tempArr.push(list);
    }

    if ((list as any).control_types) {
      const temp = (list as any).control_types.map((item) => item.id);
      id = `${id}-${temp.join("-")}`;
      (list as any).childIds = temp.join("-");
      tempArr.push(list);
    }

    list.childIds = id;
    list.industry_group = tempArr;
    return list;
  }

  async mounted() {
    window.removeEventListener("click", () => {});
    this.inputDivId = "select-multiple-level" + this.info.id;

    EventEmitter.on("APP_SELECT_MULTI_LEVEL_SETITEMS", (async (input: any) => {
      const { level, item } = input;

      return await this.setSelectedItem(item, level);
    }) as any);

    this.primaryPlaceholder = this.getUiText(
      "app-prospect-questions-select-text-1",
    );
    if (this.info.name) {
      this.primaryPlaceholder += " " + this.info.name;
    }

    this.setPlaceholderValue();

    setTimeout(async () => {
      let typeVals: any = [];
      const temp: any = [];
      if (!this.info?.type_values?.sector) {
        let listKeyInJSON = await Utils.getQuestionsMatchedListKey(
          this.info.id,
        );
        this.info.type_values.sector = this.info.type_values[listKeyInJSON];
      }
      for (let i of this.info.type_values.sector) {
        i = this.addChildIdsString(i);
        temp.push(i);
      }

      this.info.type_values.sector = temp;
      if (this.info && this.info.type_values) {
        let listKeyInJSON = await Utils.getQuestionsMatchedListKey(
          this.info.id,
        );

        if (
          this.info.type_values[listKeyInJSON] &&
          this.info.type_values[listKeyInJSON].length > 0
        ) {
          typeVals = this.info.type_values[listKeyInJSON];
          typeVals = _.sortBy(typeVals, "order");
        }
      }

      if (typeVals.length > 0) {
        this.selectedItems = [];

        this.valsToFind = this.info.values ? [].concat(this.info.values) : []; // To check previously selected items.

        for (let i in typeVals) {
          await this.checkInList(typeVals[i], 1);
        }
      }
      this.masterList = [];
      this.masterList = [].concat(typeVals);
      this.allList = [].concat(typeVals);

      this.setPlaceholderValue();
      this.adjustDropdownWidth();

      const multiLevelDropdown = document.getElementById("multiLevelDropdown");
      if (multiLevelDropdown) {
        multiLevelDropdown.addEventListener(
          "hidden.bs.dropdown",
          this.onCloseDropdownMenu,
        );
      }
    }, 0);
    window.addEventListener("resize", this.adjustDropdownWidth);

    window.addEventListener("click", (e: any) => {
      const targetClassList: string[] = [...e.target.classList];

      if (
        !targetClassList.includes("select-placeholder") &&
        !targetClassList.includes("search-dropdown") &&
        !targetClassList.includes("dropdown-button-arrow") &&
        !targetClassList.includes("dropdown-button-arrow-img")
      ) {
        this.showIcon = false;
      }
    });
    this.setPlaceholderValue();
    this.updateUIVariables();

    const multiLevelDropdown = document.getElementById("multiLevelDropdown");
    if (multiLevelDropdown) {
      multiLevelDropdown.addEventListener(
        "hidden.bs.dropdown",
        this.onCloseDropdownMenu,
      );
    }
  }
  async checkInList(list: any, level: any) {
    /* eslint-disable */
    for (let k in list) {
      const nextLevelListKey = await Utils.getListDataKeyAtLevel(
        this.info.id,
        level,
      );
      list.canDisplay = true;

      if (this.longestItem.length < list.name.length) {
        this.longestItem = list.name;
        this.longestItemLevel = level;
      }

      if (
        nextLevelListKey &&
        list[nextLevelListKey] &&
        list[nextLevelListKey].length > 0
      ) {
        if (Array.isArray(list[nextLevelListKey])) {
          const nxtLvl = level + 1;
          for (let k in list[nextLevelListKey]) {
            await this.checkInList(list[nextLevelListKey][k], nxtLvl);
          }
        } else {
          await this.checkInList(list[nextLevelListKey], level + 1);
        }
      } else if (_.isObject(list) && list.id) {
        if (this.valsToFind.length > 0) {
          await this.insertIfKeyValueExists([list]);
        }
      }
    }
  }
  insertIfKeyValueExists(itemList: any) {
    if (itemList && itemList.length > 0) {
      for (let n: number = 0; n < this.valsToFind.length; n++) {
        const itemRec = _.find(itemList, { id: this.valsToFind[n] });
        if (itemRec) {
          this.selectedItems.push(itemRec);
          this.valsToFind.splice(n, 1);
          n = n - 1;
        }
      }
    }
  }
  onClickMenu(e: any) {
    this.showIcon = !this.showIcon;
    setTimeout(() => {
      this.enableSearch && $(this.$refs.search as any).focus();
    }, 100);
    if (this.showIcon && e && e.currentTarget && e.currentTarget.id) {
      EventEmitter.emit("APP_SCROLL_BOTTOM_CUSTOM", e.currentTarget.id);

      // Get list's first element offsetTop.
      setTimeout(() => {
        this.setOffset();
      }, 100);
    }
    const searchBtn = document.getElementById("search-btn");
    const dDForm = document.getElementById("dropdown-scroll");
    const dDButton = document.getElementById("dropdownMenuButton");
    if (searchBtn && dDButton && dDForm) {
      searchBtn.style.width = dDButton.offsetWidth + "px";
      dDForm.style.width = dDButton.offsetWidth + "px";
    }
  }
  setOffset() {
    const b = document.getElementsByClassName("dropdown-item-row");
    if (b && b.length > 0 && b[0]) {
      const c =
        $(b[0]).find(".item-parent") &&
        $(b[0]).find(".item-parent").find(".dropdown-item");
      this.itemOffsetMain = c && c[0] && (c[0] as any).offsetTop;
    }
  }
  setPlaceholderValue() {
    // alert(this.getUiText("app-prospect-questions-items-selected-text"));
    if (this.selectedItems && this.selectedItems.length > 0) {
      this.selectPlaceholder =
        this.selectedItems.length +
        " " +
        this.getUiText("app-prospect-questions-items-selected-text");
    } else if (this.info.prompt) {
      this.selectPlaceholder = this.info.prompt;
    } else {
      this.selectPlaceholder = this.primaryPlaceholder;
    }
  }
  setSelectedItem(item: any, level: any) {
    if (item && level) {
      const itemRecIndex = this.selectedItems.findIndex(
        (r: any) => r.id === item.id,
      );
      if (itemRecIndex >= 0) {
        // to deselect selected item.
        this.selectedItems.splice(itemRecIndex, 1);
      } else {
        this.selectedItems.push(item);
      }
      this.setPlaceholderValue();
    }

    return true;
  }
  onRemoveItem(itemIndex: number) {
    if (itemIndex >= 0) {
      this.selectedItems.splice(itemIndex, 1);
      this.setPlaceholderValue();
    }
  }
  onCloseDropdownMenu() {
    this.showIcon = false;
    this.search = "";
  }
  onClickRemoveAll(e: any) {
    e.stopPropagation();
    this.selectedItems = [];
    this.setPlaceholderValue();
  }
  beforeUnmount() {
    this.selectedItems = [];
    this.allList = [];
    this.masterList = [];
    EventEmitter.off("APP_SELECT_MULTI_LEVEL_SETITEMS");
    window.removeEventListener("click", (e) => {});
  }
}
</script>
<style lang="scss" scoped>
.selected-item-card {
  border-radius: 30px;
  background: #ffffff;
  border: 2px solid #0345bd;
  color: #0345bd;
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  margin-right: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.select-card-ques {
  color: #231f20;
}
.dropdown-button {
  width: fit-content;
  background: #ffffff;
  display: flex;
  border: 3px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  color: #0345bd;
  padding-left: 5px;
  border: 0px !important;
}
.select-placeholder {
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
  text-align: left;
  word-break: break-word;
}
.select-placeholder-default {
  color: #b7b7b7;
}
.select-placeholder::placeholder {
  font-size: 32px;
}
.dropdown-menu {
  margin-top: 0px;
  width: 100%;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  border: none;
  display: contents;
}
.dropdown-item {
  color: #0345bd;
  font-size: 18px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: auto;
}
.checkbox-custom {
  opacity: 0;
  position: absolute;
  width: 24px;
  height: 24px;
}

.checkbox-custom,
.checkbox-custom-label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
}

.checkbox-custom-label {
  position: relative;
  font-style: normal;
  font-weight: normal;
  // font-size: 16px;
  line-height: 24px;
}

.checkbox-custom + .checkbox-custom-label:before {
  content: "";
  background: #fff;
  border: 2px solid #0345bd;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  padding: 0px;
  margin-right: 10px;
  text-align: center;
  border-radius: 50%;
}

.checkbox-custom:focus + .checkbox-custom-label,
.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd; /* focus style */
}
.search-icon {
  position: absolute;
  margin-top: 10px;
  left: 20px;
}
.confirm-btn {
  border: 3px solid #0345bd;
  border-radius: 200px;
  color: #0345bd;
  font-size: 16px;
  padding: 10px 20px;
  width: unset !important;
}
.search-dropdown {
  border: none;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: 100%;
  font-size: 18px;
  padding: 10px;
  padding-left: 53px;
  line-height: 27px;
  font-style: normal;
  font-weight: 500;
}
.selected-item {
  background: #0345bd;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  color: white;
  border: none;
}
.dropdown-scroll {
  max-height: 450px;
  overflow-y: auto;
}
.selected-item-container {
  margin-top: 10px;
  .item-close {
    padding-left: 10px;
  }
}
.button-arrows {
  img {
    margin-top: 0px;
  }
}

@media (max-width: 812px) and (min-width: 769px) and (orientation: landscape) {
  .dropdown-button {
    width: fit-content !important;
  }
}
@media (max-width: 500px) {
  .dropdown-button {
    width: 100% !important;
  }
}
</style>
